import { render, staticRenderFns } from "./TemplateTermin.vue?vue&type=template&id=4004d190"
import script from "./TemplateTermin.vue?vue&type=script&lang=js"
export * from "./TemplateTermin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports